// extracted by mini-css-extract-plugin
export default {"wrapper":"RelationEnt_wrapper__9kl1o","title":"RelationEnt_title__T6AZh","sectionBg":"RelationEnt_sectionBg__iNUo4"};